<template lang="html">
  <b-field
    message='On Youtube, click on "Share" button then copy the end of the URL in the field above'
  >
    <template slot="label">
      Video
      <b-tooltip
        position="is-right"
        type="is-dark"
        label="Video to illustrate the content"
      >
        <b-icon type="is-gray" size="is-small" icon="help-circle-outline"></b-icon>
      </b-tooltip>
    </template>
    <p class="control">
      <span class="button is-static">https://youtu.be/</span>
    </p>
    <b-input
      v-model="localVideo"
      maxlength="30"
      placeholder="dQw4w9WgXcQ"
      expanded
      @input="updateVideo"
    />
  </b-field>
</template>

<script>
export default {
  props: ['video'],
  data () {
    return {
      localVideo: null
    }
  },
  created () {
    this.localVideo = this.video
  },
  methods: {
    updateVideo (value) {
      this.$emit('updateVideo', value)
    }
  }
}
</script>

<style lang="scss" scoped></style>
